import { defineMessages } from 'react-intl';

export const scope = 'axionimprovements.features.toplevelcategories';

export default defineMessages({

    // no: {
    //     id: `${scope}.labels.no`,
    //     defaultMessage: 'No',
    // },
    // yes: {
    //     id: `${scope}.labels.yes`,
    //     defaultMessage: 'Yes',
    // },

    add_category: {
        id: `${scope}.labels.add_category`,
        defaultMessage: 'Add calendar.',
    },
    update_category: {
        id: `${scope}.labels.add_category`,
        defaultMessage: 'Update calendar.',
    },
    delete_category: {
        id: `${scope}.labels.delete_category`,
        defaultMessage: 'Delete calendar.',
    },
    add_a_new_category: {
        id: `${scope}.labels.add_a_new_category`,
        defaultMessage: 'Add a new calendar.',
    },
    update_a_category: {
        id: `${scope}.labels.update_a_category`,
        defaultMessage: 'Update a calendar.',
    },
    could_not_update_category: {
        id: `${scope}.labels.could_not_update_category`,
        defaultMessage: 'Could not update the calendar.',
    },
    could_not_create_category: {
        id: `${scope}.labels.could_not_create_category`,
        defaultMessage: 'Could not create the calendar.',
    },
    edit_category: {
        id: `${scope}.labels.edit_category`,
        defaultMessage: 'Edit the calendar.',
    },
    categories: {
        id: `${scope}.labels.categories`,
        defaultMessage: 'Calendars.',
    },
    topLevelCategories: {
        id: `${scope}.labels.topLevelCategories`,
        defaultMessage: 'Top level calendar.',
    },
    edit: {
        id: `${scope}.labels.edit`,
        defaultMessage: 'Edit.',
    },
    order: {
        id: `${scope}.labels.order`,
        defaultMessage: 'Sort order.',
    },
    organization: {
        id: `${scope}.labels.organization`,
        defaultMessage: 'Organization.',
    },
    lbl_name: {
        id: `${scope}.labels.lbl_name`,
        defaultMessage: 'Name.',
    },
    btn_close: {
        id: `${scope}.labels.btn_close`,
        defaultMessage: 'Close.',
    },
    category: {
        id: `${scope}.labels.category`,
        defaultMessage: 'Calendar.',
    },
    department: {
        id: `${scope}.labels.department`,
        defaultMessage: 'Department.',
    },
    add_categories: {
        id: `${scope}.labels.add_categories`,
        defaultMessage: 'Add calendars.',
    },
    add_edit_categories: {
        id: `${scope}.labels.add_edit_categories`,
        defaultMessage: 'Add/Edit connected calendars.',
    },
    save_category: {
        id: `${scope}.labels.save_category`,
        defaultMessage: 'Save the calendar.',
    },
    noneSelected: {
        id: `${scope}.labels.noneSelected`,
        defaultMessage: 'None selected.',
    },

});